// Delete action builder. Only composed into the action list when the
// signed-in user is the message sender — the host row enforces that
// gate; the builder simply describes the affordance.
//
// The actual redaction goes through `useMessageActions.deleteMessage`
// after the user confirms in the `DeleteConfirmDialog`.

import { Trash2 } from "lucide-react";

import type { MessageAction } from "~/components/MessageActions";

export function buildDeleteAction(params: {
  onClick: () => void;
  disabled?: boolean;
}): MessageAction {
  return {
    id: "delete",
    label: "Delete",
    icon: Trash2,
    onClick: params.onClick,
    disabled: params.disabled,
  };
}
